export default "__VITE_ASSET__mPAthtM1__"